import React from "react";
import "./UsagePage.css";

const UsagePage = () => {
  return (
    <div className="usage">
      <div className="usage-container">
        <h1 className="usage-title">We guarantee security.</h1>
        <h3 className="usage-subtitle">
          Privalink takes your data seriously. After someone views the message,
          the all the data from our system is deleted. The auto-generated URL is
          also destroyed and removed from the internet.
        </h3>
      </div>
    </div>
  );
};

export default UsagePage;
